import { makeStyles } from "@material-ui/core/styles";

/**
 * Shared styles hook for Period Row components.
 * Reduces duplication across pharmacyPeriodRow, pharmaCompanyPeriodRow, and oriolaPeriodRow.
 */
export const usePeriodRowStyles = makeStyles(theme => ({
  periodContainer: {
    textTransform: "none",
  },
  row: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    marginTop: theme.spacing(2),
    borderTop: "solid 2px transparent",
  },
  rowExpanded: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    marginTop: theme.spacing(2),
    borderTop: "solid 2px #ffa000",
  },
  periodOverviewContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  periodOverview: {
    width: "60%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  expandIcon: {
    marginRight: theme.spacing(1),
  },
  expandIconLarge: {
    marginLeft: "0.5rem",
    marginRight: "1rem",
  },
  titleContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  submissionText: {
    ...theme.typography.subtitle2,
    color: theme.palette.text.disabled,
    marginRight: theme.spacing(2),
  },
  error: {
    color: "red",
    ...theme.typography.body1,
  },
  headerDivider: {
    height: 0,
    margin: theme.spacing(3),
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(3),
  },
  contentContainer: {
    marginLeft: "1rem",
    marginRight: "1rem",
  },
  periodDetailsContainer: {
    display: "flex",
    flexDirection: "row",
    marginLeft: "3rem",
    marginRight: "3rem",
  },
  updateProgress: {
    marginLeft: "1.5rem",
    marginRight: "1.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    marginTop: theme.spacing(4),
  },
}));

export default usePeriodRowStyles;
